import { blue, deepPurple, green, lightGreen, lime, orange, pink, purple, red, teal } from '@mui/material/colors';

import { BearingEnvelopeType } from '@paragon/contract-library';

export const layoutColors = {
  bearingEnvelopes: {
    normal: blue[500],
    faded: blue[200],
    emphasised: blue[800],
  },
  beamEnvelopes: {
    normal: teal[400],
    faded: teal[200],
    emphasised: teal[700],
  },
  nonStructuralBearingEnvelopes: {
    normal: purple[400],
    faded: purple[200],
    emphasised: purple[600],
  },

  solidMeshEdges: 'black',

  // colors for roof containers only
  overhangs: deepPurple[500],
  roofMesh: {
    primary: purple[500],
    alternate: purple[300],
  },

  roofLines: purple[500],

  workLines: {
    normal: purple[200],
    hovered: purple[400],
  },

  boundingWorkLines: {
    normal: red[200],
    hovered: red[400],
  },

  entitySnap: lightGreen['A400'],
  entitySnapForceAbsolute: orange['A400'],

  trussEnvelopes: {
    normal: {
      line: orange[200],
      overhang: orange[50],
      definitionLine: orange[200],
    },

    highlighted: {
      line: green[600],
      overhang: green[50],
      definitionLine: green[600],
    },

    faded: {
      line: orange[100],
      overhang: '#ffffff',
      definitionLine: orange[100],
    },

    emphasised: {
      line: orange[400],
      overhang: '#ffffff',
      definitionLine: orange[800],
    },
  },

  envelopeDirectionIndicator: 0x00ff00,

  roofFaces: {
    highlightHue: green,

    hues: {
      roof: pink,
      ceiling: lime,
      featurePattern: teal,
      featureArea: red,
    },

    tints: {
      normal: 400,
      barelyEmphasised: 500,

      faded: 200,
      fadedButBarelyEmphasised: 300,

      emphasised: 700,
      highlighted: 600,
    },
  },

  preferredConnections: {
    TopChord: pink[300],
    BottomChord: lime[300],
    TopAndBottomChords: '#e6a584',
    None: 'red',
  },

  jackGirderConnections: {
    TopChord: pink['A400'],
    BottomChord: green['A700'],
    TopAndBottomChords: orange['A700'],
  },

  hangers: 'gray',
} as const;

export function getBearingEnvelopeColors(bearingType: BearingEnvelopeType, structural: boolean) {
  return bearingType === 'Beam'
    ? layoutColors.beamEnvelopes
    : structural
      ? layoutColors.bearingEnvelopes
      : layoutColors.nonStructuralBearingEnvelopes;
}
